/*
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("scrollToTop");

  if (!btn) return;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      btn.classList.add("show");
    } else {
      btn.classList.remove("show");
    }
  });

  btn.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});
*/
document.addEventListener('DOMContentLoaded', function () {
  const phoneInput = document.querySelector('.field--phone');
  if (!phoneInput) return;

  phoneInput.addEventListener('input', function () {
    this.value = this.value.replace(/[^0-9]/g, '');
  });
});
document.addEventListener("click", function (e) {
  const summary = e.target.closest(".menu-drawer__menu summary");
  if (!summary) return;

  const currentDetails = summary.closest("details.menu-opening");
  if (!currentDetails) return;

  // Close other open menu items inside menu drawer only
  const menuDrawer = summary.closest(".menu-drawer__menu");

  menuDrawer
    .querySelectorAll("details.menu-opening[open]")
    .forEach((details) => {
      if (details !== currentDetails) {
        details.removeAttribute("open");
      }
    });
});
/*
Hide triple dot button on video
*/
document.addEventListener("DOMContentLoaded", function () {

  const videos = document.querySelectorAll("video");

  videos.forEach(video => {

    // Disable PiP API
    video.disablePictureInPicture = true;

    video.addEventListener("enterpictureinpicture", (event) => {
      event.preventDefault();
      video.disablePictureInPicture = true;
      document.exitPictureInPicture().catch(()=>{});
    });

    // Block right-click menu PiP
    video.addEventListener("contextmenu", e => e.preventDefault());

    // Stop keyboard shortcut (Chrome: Alt+P)
    document.addEventListener("keydown", function(e){
      if (e.key === "p" && (e.metaKey || e.ctrlKey || e.altKey)) {
        e.preventDefault();
      }
    });

  });

});

